import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=47c356da&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c356da')) {
      api.createRecord('47c356da', component.options)
    } else {
      api.reload('47c356da', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=47c356da&", function () {
      api.rerender('47c356da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OgcXJDgKSjR5/JS/offershelp.vue"
export default component.exports